var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#b6b6b6",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,6c-15.5,0 -30.1,6 -41,17c-11,10.9 -17,25.5 -17,41c0,15.5 6,30.1 17,41c11,11 25.5,17 41,17c15.5,0 30.1,-6 41,-17c11,-11 17,-25.5 17,-41c0,-15.5 -6,-30.1 -17,-41c-10.9,-11 -25.5,-17 -41,-17zM64,12c13.9,0 26.90078,5.39922 36.80078,15.19922c9.9,9.8 15.19922,22.90078 15.19922,36.80078c0,13.9 -5.39922,26.90078 -15.19922,36.80078c-9.9,9.8 -22.90078,15.19922 -36.80078,15.19922c-13.9,0 -26.90078,-5.39922 -36.80078,-15.19922c-9.9,-9.8 -15.19922,-22.90078 -15.19922,-36.80078c0,-13.9 5.39922,-26.90078 15.19922,-36.80078c9.8,-9.9 22.90078,-15.19922 36.80078,-15.19922zM50.5625,47.5c-0.7625,0 -1.5125,0.30039 -2.0625,0.90039c-1.2,1.2 -1.2,3.09922 0,4.19922l11.30078,11.40039l-11.40039,11.30078c-1.2,1.2 -1.2,3.09922 0,4.19922c0.6,0.6 1.39961,0.90039 2.09961,0.90039c0.7,0 1.49961,-0.30039 2.09961,-0.90039l11.40039,-11.30078l11.30078,11.30078c0.6,0.6 1.39961,0.90039 2.09961,0.90039c0.7,0 1.49961,-0.30039 2.09961,-0.90039c1.2,-1.2 1.2,-3.09922 0,-4.19922l-11.30078,-11.30078l11.30078,-11.30078c1.2,-1.2 1.19961,-3.09883 0.09961,-4.29883c-1.2,-1.2 -3.09922,-1.2 -4.19922,0l-11.40039,11.40039l-11.30078,-11.40039c-0.6,-0.6 -1.37422,-0.90039 -2.13672,-0.90039z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCancel);
export default __webpack_public_path__ + "static/media/calendar_cancel.8b63894f89a35f690a4320b3476e0a5b.svg";
export { ForwardRef as ReactComponent };